import { post, get, postJson } from '../request';
import urls from './apilist';

/**
 * 获取购物车列表
 */
function getCart(params) {
  return get(urls.getCart, params);
}

/**
 * 获取收货地址
 * @param params
 * @returns {*}
 */
function getAddress(params) {
  return get(urls.getAddress, params);
}

/**
 * 添加购物车
 * @param params
 * @returns {*}
 */
function saveCart(params) {
  return postJson(urls.saveCart, params);
}

/**
 * /更新购物车
 * @param params
 * @returns {*}
 */
function updateCarts(params) {
  return post(urls.updateCarts, params);
}
/**
 * 删除购物车
 * @param params
 * @returns {*}
 */
function deleteCarts(ids) {
  return post(urls.deleteCarts, {ids});
}

/**
 * 获取购物车数量
 * @returns {*}
 */
function getCartNum() {
  return get(urls.getCartNum)
}

/**
 * 新增收货地址
 * @param params
 * @returns {*}
 */
function saveAddress(params) {
  return postJson(urls.saveAddress, params);
}

/**
 * 编辑收货地址
 * @param params
 */
function updateAddress(params) {
  return postJson(urls.updateAddress, params);
}

/**
 * 批量勾选购物车商品
 * @param params
 * @returns {*}
 */
function selectCarts(params) {
  return postJson(urls.selectCarts, params);
}

/**
 * 结算
 * @param params
 * @returns {*}
 */
function generateOrder(params) {
  return postJson(urls.generateOrder, params);
}

/**
 * 获取订单列表
 * @param params
 * @returns {*}
 */
function getOrders(params) {
  return get(urls.getOrders, params);
}

function getOrderByName(params) {
  return get(urls.getOrderByName, params)
}

/**
 * 获取订单详情
 * @param params
 * @returns {*}
 */
function getOrderDetail(params) {
  return get(urls.getOrderDetail, params);
}

function getSign(params) {
  return get(urls.getSign, params);
}

/**
 * 鉴权
 * @param code
 * @returns {*}  isBindPhone ：是否绑定过手机号 2：无 1：绑定了
 */
function authentication(code) {
  return post(urls.authentication, {code})
}

/**
 * 获取用户信息
 * @returns {*}
 */
function getUserInfo() {
  return get(urls.getUserInfo)
}

/**
 * 绑定手机号
 * @param params
 * @returns {*}
 */
function bindPhone(params) {
return post(urls.bindPhone, params)
}

/**
 * 删除订单
 * @param OSns
 * @returns {*}
 */
function deleteOrder(OSns) {
  return post(urls.deleteOrders, {OSns})
}

/**
 * 保存订单
 * @param params
 * @returns {*}
 */
function saveEvaluate(params) {
  return postJson(urls.saveEvaluate, params)
}

/**
 * 发起支付
 * @returns {*}
 */
function payByJSSDK(orderSn) {
  return get(urls.payByJSSDK, {orderSn})
}

//修改订单状态
function changeOrderStatus(params) {
  return post(urls.changeOrderStatus, params)
}

//查询订单物流
function getLogistics(params) {
  return get(urls.getLogistics, params)
}

//退换货
function returnGoods(params) {
  return postJson(urls.returnGoods, params)
}

//删除收货地址
function deleteAddress(ids) {
  return post(urls.deleteAddress, {
    ids
  })
}

function updateUserInfo(params) {
  return postJson(urls.updateUserInfo, params)
}

//申请入驻
function settleIn(params) {
  return postJson(urls.settleIn, params)
}

//入驻申请列表
function getSettleRecord(params) {
  return get(urls.getSettleRecord, params);
}

//申请成为分销员
//参数 name姓名,String smsCode手机验证码
function applyDistributor(params) {
  return postJson(urls.applyDistributor, params)
}
const apis = {
  getCart,
  getAddress,
  saveCart,
  updateCarts,
  deleteCarts,
  getCartNum,
  saveAddress,
  selectCarts,
  updateAddress,
  generateOrder,
  getOrders,
  getOrderByName,
  getOrderDetail,
  getSign,
  authentication,
  getUserInfo,
  bindPhone,
  deleteOrder,
  saveEvaluate,
  payByJSSDK,
  changeOrderStatus,
  getLogistics,
  returnGoods,
  deleteAddress,
  updateUserInfo,
  settleIn,
  getSettleRecord,
  applyDistributor
};

export default apis;
